module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAKCAYAAAC9vt6cAAAAAXNSR0IArs4c6QAAAPZJREFUKFOl0jFKQ0EUheFvjKQQtDOFhWBEUmgpCha6AUWzBjULCBbB2mAj7kHsRFAraytB0wpK3EAKG8FCJI6854vNpBAyxQycc+eHc+8NihP3bQqaWBX1BR3RqZaeYAc1fKPry02oeci+huyKDW0cDmB/72KO66p4STwuQtV5iHu2jblOCmawVqgVj6b0kprgKMSGO6wn5gamC7Xszaz7pCZ6ygAfmEjMOkqFGvTNux0S4zMDvGMyMbO2jf8PMGKEUZrY1x6M8RitJMYSVryqeB4ygcsw5ywH5Luwa0vJAZYLqSM40dRTVhct5HrQFV2F6u8i/QDpjUYMS7YD6wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/prefix-01.png
// module id = iIwD
// module chunks = 1